var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "a-row",
        { attrs: { gutter: [16, 48], type: "flex" } },
        [
          _c("a-col", { attrs: { span: 24 } }, [
            _c(
              "fieldset",
              [
                _c("legend", [
                  _vm._v(" " + _vm._s(_vm.$t("lbl_basic_feature")) + " ")
                ]),
                _c(
                  "a-row",
                  { attrs: { gutter: [16, 16], type: "flex" } },
                  [
                    _c("a-col", { attrs: { span: 6 } }, [
                      _c("p", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("lbl_basic_invoice_term")) + " "
                        )
                      ])
                    ]),
                    _c(
                      "a-col",
                      { attrs: { span: 6 } },
                      [
                        _c("a-select", {
                          staticClass: "w-100",
                          attrs: {
                            options: _vm.topOptions,
                            loading: _vm.loading.invoiceTerms,
                            "label-in-value": "",
                            "data-testid": "sales-invoice-terms"
                          },
                          model: {
                            value: _vm.state.field.sales.invoiceTerms.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.state.field.sales.invoiceTerms,
                                "value",
                                $$v
                              )
                            },
                            expression: "state.field.sales.invoiceTerms.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: [16, 16], type: "flex" } },
                  [
                    _c("a-col", { attrs: { span: 6 } }, [
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("lbl_quotation_and_sales_order")) +
                            " "
                        )
                      ])
                    ]),
                    _c(
                      "a-col",
                      { attrs: { span: 6 } },
                      [
                        _c("a-select", {
                          staticClass: "w-100",
                          attrs: {
                            options: _vm.booleanOptions,
                            "data-testid": "sales-sales-quotation"
                          },
                          model: {
                            value:
                              _vm.state.field.sales.salesAndQuotation.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.state.field.sales.salesAndQuotation,
                                "value",
                                $$v
                              )
                            },
                            expression:
                              "state.field.sales.salesAndQuotation.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: [16, 16], type: "flex" } },
                  [
                    _c("a-col", { attrs: { span: 6 } }, [
                      _c("p", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("lbl_sales_order_return")) + " "
                        )
                      ])
                    ]),
                    _c(
                      "a-col",
                      { attrs: { span: 6 } },
                      [
                        _c("a-select", {
                          staticClass: "w-100",
                          attrs: {
                            options: _vm.booleanOptions,
                            "data-testid": "sales-sales-return"
                          },
                          model: {
                            value: _vm.state.field.sales.salesOrderReturn.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.state.field.sales.salesOrderReturn,
                                "value",
                                $$v
                              )
                            },
                            expression:
                              "state.field.sales.salesOrderReturn.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: [16, 16], type: "flex" } },
                  [
                    _c("a-col", { attrs: { span: 6 } }, [
                      _c("p", [
                        _vm._v(" " + _vm._s(_vm.$t("lbl_join_invoice")) + " ")
                      ])
                    ]),
                    _c(
                      "a-col",
                      { attrs: { span: 6 } },
                      [
                        _c("a-select", {
                          staticClass: "w-100",
                          attrs: {
                            options: _vm.booleanOptions,
                            "data-testid": "sales-invoice-join"
                          },
                          model: {
                            value: _vm.state.field.sales.invoiceJoin.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.state.field.sales.invoiceJoin,
                                "value",
                                $$v
                              )
                            },
                            expression: "state.field.sales.invoiceJoin.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: [16, 16], type: "flex" } },
                  [
                    _c("a-col", { attrs: { span: 6 } }, [
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "lbl_disabled_sell_when_not_enough_quantity"
                              )
                            ) +
                            " "
                        )
                      ])
                    ]),
                    _c(
                      "a-col",
                      { attrs: { span: 6 } },
                      [
                        _c("a-select", {
                          staticClass: "w-100",
                          attrs: {
                            options: _vm.booleanOptions,
                            "data-testid": "sales-sell-quantity"
                          },
                          model: {
                            value:
                              _vm.state.field.sales.disableSellQuantity.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.state.field.sales.disableSellQuantity,
                                "value",
                                $$v
                              )
                            },
                            expression:
                              "state.field.sales.disableSellQuantity.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: [16, 16], type: "flex" } },
                  [
                    _c("a-col", { attrs: { span: 6 } }, [
                      _c("p", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("lbl_sales_commision")) + " "
                        )
                      ])
                    ]),
                    _c(
                      "a-col",
                      { attrs: { span: 6 } },
                      [
                        _c("a-select", {
                          staticClass: "w-100",
                          attrs: {
                            options: _vm.salesCommisionOptions,
                            loading: _vm.loading.salesCommision,
                            "data-testid": "sales-sales-commision",
                            "label-in-value": ""
                          },
                          model: {
                            value: _vm.state.field.sales.salesCommision.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.state.field.sales.salesCommision,
                                "value",
                                $$v
                              )
                            },
                            expression: "state.field.sales.salesCommision.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "a-row",
        { staticClass: "mt-3", attrs: { gutter: [16, 48], type: "flex" } },
        [
          _c(
            "a-col",
            { attrs: { span: 6 } },
            [
              _vm.$can("update", "preferences")
                ? _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        "data-testid": "sales-save",
                        loading: _vm.state.loadingSave
                      },
                      on: { click: _vm.onSave }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("lbl_save")) + " ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }